export const LAST_KEY = "mpwrd_last_result";
const LENS_KEY = { staff: "mpwrd_last_staff", manager: "mpwrd_last_manager" };

export const rememberResult = (mode, id) => {
  localStorage.setItem(LENS_KEY[mode], id);
  if (mode === "staff") localStorage.setItem(LAST_KEY, id);
};

export const deviceResults = () => ({
  staff: localStorage.getItem(LENS_KEY.staff) || localStorage.getItem(LAST_KEY),
  manager: localStorage.getItem(LENS_KEY.manager),
});

export const otherLens = (id, compareWith) => {
  if (compareWith) return compareWith;
  const d = deviceResults();
  if (!d.staff || !d.manager) return null;
  if (id === d.staff) return d.manager;
  if (id === d.manager) return d.staff;
  return null;
};
